<template>
	
	<div class = 'footer_box'>
		
		<div>
			
			<!-- <div class = 'lxfs'>
				
				<div class = 'dh'>
					
					 <a><img src  = "../../assets/电话.png"></a>
					  <p>客服支持</p>
					  <p>0756-2266692</p>
					 
				</div>
				<div class = 'dh'>
					<a target = '_blank' href="http://wpa.qq.com/msgrd?v=3&uin=3341177121&site=qq&menu=yes"><img src  = "../../assets/qq.png" /></a>
					 <p>在线咨询</p>
					 <p>8:30 - 17:30</p>
					
				</div>
				
			</div> -->
			
			<!-- <div class = 'qr'>
				
				<img src = "../../assets/eq.png" />
				
			</div> -->
		</div>
		<div class = 'line'></div>
		<div class = "footer_nav">
			
			<span class = "footer_nav_title">关于我们</span>
			<span class = "footer_nav_title">新手指导</span>
			<span class = "footer_nav_title">使用帮助</span>
			<span class = "footer_nav_title">实力保障</span>
			
			<span>平台介绍</span>
			<span>我要咨询</span>
			<span>安全保障</span>
			<span>公司证件</span>
			<span>企业愿景</span>
			<span>我要建议</span>
			<span>网站协议</span>
			<span>资费说明</span>
			
			<span>联系我们</span>
			<span>我要投诉</span>
			<span>帮助中心</span>
			<span>政策法规</span>
			
		</div>
		<div class = "bottom_info">
			
			<p>
				<span>首页&nbsp;&nbsp;|&nbsp;&nbsp;</span>
				<span v-for="(item,index) in systemData.topOrderType" :key = "index">{{item.label}}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
				<span>关于我们</span>
			</p>
			<p style="color: #cccccc;">
				<a href = "http://www.beian.miit.gov.cn/" target="_blank" style = "color:#FFFFFF">粤ICP备2022046534号-1</a>   Copyright 2020 余米科技有限公司 版权所有
			</p>
			
		</div>
		
	</div>
	
	
</template>

<script>
	import {mapGetters} from 'vuex'
	export default{
		computed:{
	...mapGetters(['systemData'])
},
	}
	
</script>

<style>
	.line{
		
		width: 0.052vw;
			height: 6.927vw;
			background-color: #cccccc;
		margin-left: 3.5vw;
		margin-right: 3.5vw;
	}
	.footer_box{
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
			width: 100vw;
			height: 18.842vw;
			background-color: #161616;
		
	}
	.dh img{
		width: 2.604vw;
		height: 2.656vw;
		
		
		
	}
	.dh a{
		grid-row-start: span 2;
	}
	.dh p{
		margin: 0;
		font-size: 0.9vw;
	}
	.dh{
		margin-bottom: 1vw;
		display: grid;
		grid-template-columns: 2.604vw 6.823vw;
		grid-template-rows: 0.99vw 0.99vw;
		grid-row-gap: 0.433vw;
		grid-column-gap: 0.781vw;
		
	}
	.qr img{
	
			width: 6.094vw;
			height: 6.094vw;
	}
	.footer_box>div:nth-child(1){
		
		display: grid;
		grid-template-columns: 10.25vw 5.781vw;
		grid-column-gap: 4.427vw;
		
	}
	.footer_box>div:nth-child(3){
		
		display: grid;
		grid-template-columns: 4vw 4vw 4vw 4vw;
		grid-template-rows: 0.938vw 0.677vw 0.677vw 0.677vw;
		grid-row-gap: 0.833vw;
		grid-column-gap: 5.417vw;
		
	}
	.footer_nav_title{
		
		
		font-size: 0.938vw;
		color: #ffffff;
	}
	.footer_nav{
		
		font-size: 0.729vw;
		color: #ffffff;
		
	}
	.footer_nav span{
		text-align: left;
	}
	.lxfs p{
		
		color: #FFFFFF;
		
	}
	.bottom_info{
		
		width: 100vw;
		height: 5.26vw;
		background-color: #232323;
		
		
	}
	.bottom_info span{
		color: #cccccc;
	}
</style>
